module.exports = __webpack_public_path__ + "img/weixin.e4f43c0f.png";